var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.superUser || _vm.permission)?_c('v-card',{staticClass:"pa-3",attrs:{"elevation":"12","value":_vm.$route.path}},[_c('v-row',{staticClass:"d-flex justify-center"},[_c('v-col',{attrs:{"cols":"12","md":"6","sm":"12"}},[_c('v-card',{attrs:{"elevation":"12"}},[_c('ApiToken',{attrs:{"elevation":"12"}})],1)],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }